const routes = [
    //石油
    {
        path: 'petroleum',
        name: '石油',
        component: () => import('@/views/petroleum/index'),
    },
    {
        path: 'petroleum/twoPage/industry',
        name: '石油行业动态二级页',
        component: () => import('@/views/petroleum/twoPage/industry')
    },
    {
        path: 'petroleum/industry',
        name: '石油行业动态详情页',
        component: () => import('@/views/petroleum/detail/industry')
    },
    {
        path: 'petroleum/twoPage/price',
        name: '石油价格二级页',
        component: () => import('@/views/petroleum/twoPage/price')
    },
    {
        path: 'petroleum/price',
        name: '石油价格详情页',
        component: () => import('@/views/petroleum/detail/price')
    },
    {
        path: 'petroleum/twoPage/yield',
        name: '石油产量二级页',
        component: () => import('@/views/petroleum/twoPage/yield')
    },
    {
        path: 'petroleum/yield',
        name: '石油产量详情页',
        component: () => import('@/views/petroleum/detail/yield')
    },
    {
        path: 'petroleum/twoPage/report',
        name: '石油研究报告二级页',
        component: () => import('@/views/petroleum/twoPage/report')
    },
    {
        path: 'petroleum/twoPage/standard',
        name: '石油技术及标准二级页',
        component: () => import('@/views/petroleum/twoPage/standard')
    },
    {
        path: 'petroleum/twoPage/balance',
        name: '石油全球供需平衡二级页',
        component: () => import('@/views/petroleum/twoPage/balance')
    },
    {
        path: 'petroleum/twoPage/rate',
        name: '石油炼油厂开工率二级页',
        component: () => import('@/views/petroleum/twoPage/rate')
    },
    {
        path: 'petroleum/rate',
        name: '石油炼油厂开工率详情页',
        component: () => import('@/views/petroleum/detail/rate')
    },
    {
        path: 'petroleum/twoPage/exit',
        name: '石油进出口二级页',
        component: () => import('@/views/petroleum/twoPage/exit')
    },
    {
        path: 'petroleum/exit',
        name: '石油进出口详情页',
        component: () => import('@/views/petroleum/detail/exit')
    },
    {
        path: 'petroleum/twoPage/stock',
        name: '石油库存二级页',
        component: () => import('@/views/petroleum/twoPage/stock')
    },
    {
        path: 'petroleum/stock',
        name: '石油库存详情页',
        component: () => import('@/views/petroleum/detail/stock')
    },
    {
        path: 'petroleum/twoPage/change',
        name: '石油持仓二级页',
        component: () => import('@/views/petroleum/twoPage/change')
    },
    {
        path: 'petroleum/change',
        name: '石油持仓详情页',
        component: () => import('@/views/petroleum/detail/change')
    },
    {
        path: 'petroleum/twoPage/dollar',
        name: '石油美元指数二级页',
        component: () => import('@/views/petroleum/twoPage/dollar')
    },
    {
        path: 'petroleum/dollar',
        name: '石油美元指数详情页',
        component: () => import('@/views/petroleum/detail/dollar')
    },
    {
        path: 'petroleum/twoPage/difference',
        name: '石油价差二级页',
        component: () => import('@/views/petroleum/twoPage/difference')
    },
    {
        path: 'petroleum/difference',
        name: '石油价差详情页',
        component: () => import('@/views/petroleum/detail/difference')
    },
]
export default routes
